import { render, staticRenderFns } from "./packageRules.vue?vue&type=template&id=24cad4d8&scoped=true&"
import script from "./packageRules.vue?vue&type=script&lang=js&"
export * from "./packageRules.vue?vue&type=script&lang=js&"
import style0 from "./packageRules.vue?vue&type=style&index=0&id=24cad4d8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24cad4d8",
  null
  
)

export default component.exports